module.exports = __webpack_public_path__ + "img/Banner.d9d82016.png";